import { useRef, useState } from 'react';
import { TOverlayRef } from '@/common/components/Overlay/Overlay.types';

export function useModal() {
  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef<TOverlayRef>(null);

  const close = () => {
    ref.current?.close();
  };

  const onClose = () => {
    setIsOpen(false);
  };

  return {
    isOpen,
    setIsOpen,
    onClose,
    ref,
    close,
  };
}
